import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';

export const GET_ACCOUNT = gql`
  query GetAccount($id: Int!) {
    getAccount(id: $id) {
      id
      legal_name
      business_dba
      primary_contact
      email
      title
      country_code
      calling_code
      phone
      currency
      logo
      logo_id
      kiosk_logo
      kiosk_logo_id
      kiosk_warning_logo
      kiosk_warning_logo_id
      # Promoter Information
      promoter_name
      promoter_email
      promoter_phone
      website
      org_name
      promoter_type
      # Race Times
      start_time
      gate_time
      mailing {
        name
        address_line_1
        address_line_2
        city
        state
        zipcode
      }
      track {
        name
        address_line_1
        address_line_2
        city
        state
        zipcode
      }
      shipping {
        name
        address_line_1
        address_line_2
        city
        state
        zipcode
      }
      open_credits {
        credit_total
        num_credits
      }
      members {
        id
        formatted_name
        email
        cellphone
      }
      track_ids
      series_ids
      stripe_account_id
      stripe_url
      series {
        id
        name
      }
      tracks {
        id
        name
      }
      card {
        brand
        last4
      }
      janam_scanners
      janam_scanner_count
      kiosk_scanners
      kiosk_scanner_count
      pos_printers
      pos_printer_count
      pos
      pos_settings {
        payment
        calculator
        ticket_delivery
        receipt_delivery
      }
      readers {
        id
        serial_number
        label
        reader_id
      }
      pos_fee_dollar
      pos_fee_percent
      scan_out
      minimum_age
      facebook_pixel_id
      facebook_capi_token_set
      orphaned_seats
      best_available
      divisions {
        id
        name
        description
        image
        image_id
        video_url
      }
      payout_recipients {
        id
        email
        name
        created_at
      }
      notes {
        id
        title
        note
        type
        image
        image_id
        created_at
        created_by {
          id
          formatted_name
        }
      }
      inactive
      insurance_company
      # Payment Settings
      show_fee
      marketing_fee
      international_fee
      waivers {
        id
        name
      }
      agreements {
        id
        name
      }
    }
  }
`;

export function useGetAccount(currentAccount, skip = false) {
  const { data, loading, error } = useQuery(GET_ACCOUNT, {
    variables: { id: currentAccount },
    fetchPolicy: 'no-cache',
    skip: !currentAccount || skip,
  });
  return { data, loading, error };
}
